import * as React from "react";
import "../../style/fonts.css";
import "./searchHeader.css";
import translate from "../../translations/i18n";
import BackButton from "../backButton/backButton";

class SearchHeader extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this);
  }

  goBack() {
    this.props.history.goBack();
  }

  render() {
    return (
      <div className="SEARCH_HEADER_CONT">
        <div className="BACK_BUTTON" onClick={this.goBack}>
          <BackButton />
        </div>
        <div className="SEARCH_HEADER_TITLE_CONT">
          <div className="TITLE_4">{translate("USER_SEARCH_HEADLINE")}</div>
        </div>
      </div>
    );
  }
}

export default SearchHeader;



// WEBPACK FOOTER //
// ./src/components/searchUser/searchHeader.tsx